"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReassignmentConfirmationJobReceivablesPayloadSchema = exports.ReassignmentConfirmationJobReceivablesPayloadItemSchema = exports.AssignmentConfirmationJobTypeSchema = exports.AssignmentConfirmationJobTypeIterable = void 0;
const zod_1 = require("zod");
exports.AssignmentConfirmationJobTypeIterable = [
    'assignment',
    'repurchase',
    'transfer',
];
exports.AssignmentConfirmationJobTypeSchema = zod_1.z.enum(exports.AssignmentConfirmationJobTypeIterable);
exports.ReassignmentConfirmationJobReceivablesPayloadItemSchema = zod_1.z.object({
    loanProductId: zod_1.z.string(),
    externalReceivableIds: zod_1.z.array(zod_1.z.string()),
    creditFacilityId: zod_1.z.string().nullable(),
});
exports.ReassignmentConfirmationJobReceivablesPayloadSchema = zod_1.z.array(exports.ReassignmentConfirmationJobReceivablesPayloadItemSchema);
//# sourceMappingURL=AssignmentConfirmationJob.js.map